import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx'; // Make sure this is installed

const useStyles = makeStyles({
  progressContainer: {
    position: 'relative',
    height: 4,
    backgroundColor: '#e0e0e0',
    borderRadius: 4,
    width: '100%',
    marginTop: 24
  },
  progressBar: {
    height: '100%',
    backgroundColor: '#2D62ED',
    borderRadius: 4,
    transition: 'width 0.3s ease-in-out'
  }
});

const ProgressBar = ({ currentStep = 1, totalSteps = 3, containerClassName = '', barClassName = '' }) => {
  const classes = useStyles();
  const progressPercent = (currentStep / totalSteps) * 100;

  return (
    <div className={clsx(classes.progressContainer, containerClassName)}>
      <div className={clsx(classes.progressBar, barClassName)} style={{ width: `${progressPercent}%` }} />
    </div>
  );
};

export default ProgressBar;
